<template>
  <section class="bg-white shadow p-3 p-lg-4 pb-4 mb-3">
    <slot></slot>
  </section>
</template>

<style lang="scss" scoped>
section.bg-white {
  background-color: red;
  button.show-on-hover-parent {
    opacity: 0;
    transition: opacity .3s ease;
  }
  &:hover button.show-on-hover-parent {
    opacity: 1;
  }
}
</style>
